var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8235 5.19747C22.5619 4.93532 22.2068 4.78799 21.8365 4.78799C21.4662 4.78799 21.1111 4.93532 20.8495 5.19747L14.0035 12.0295L7.15749 5.18347C6.89592 4.92132 6.54081 4.77399 6.17049 4.77399C5.80016 4.77399 5.44505 4.92132 5.18349 5.18347C4.63749 5.72947 4.63749 6.61147 5.18349 7.15747L12.0295 14.0035L5.18349 20.8495C4.63749 21.3955 4.63749 22.2775 5.18349 22.8235C5.72949 23.3695 6.61149 23.3695 7.15749 22.8235L14.0035 15.9775L20.8495 22.8235C21.3955 23.3695 22.2775 23.3695 22.8235 22.8235C23.3695 22.2775 23.3695 21.3955 22.8235 20.8495L15.9775 14.0035L22.8235 7.15747C23.3555 6.62547 23.3555 5.72947 22.8235 5.19747Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhite);
export default __webpack_public_path__ + "static/media/close-white.3d1439aa.svg";
export { ForwardRef as ReactComponent };